import { useEffect, useState } from "react";
import useGlobalContext from "../../hooks/useGlobalContext";
import { Box, TextField } from "@mui/material";
import Combobox from "./Combobox";
import {
  getInputLabelProps,
  getInputProps,
  PopperFullWidth,
} from "../../common/appStyles";
import localize from "../../common/localize";

export default function AddressManagement({
  model,
  setModel,
  disableZones,
  disableAddress,
  disableAddressComplement,
}) {
  const { locations, cities, zones, setCity, setCityFilterCode } =
    useGlobalContext();

  const getBoxStyle = () => "w-full flex justify-between gap-2 items-center";
  const [states, setStates] = useState(null);
  const [citiesData, setCities] = useState(null);
  const [zonesData, setZones] = useState(null);

  useEffect(() => {
    if (locations?.Ok) {
      setStates(locations.Data ?? []);
    }
  }, [locations]);

  useEffect(() => {
    if (cities?.Ok) {
      setCities(cities.Data ?? []);
    }
  }, [cities]);

  useEffect(() => {
    if (zones?.Ok && model?.City && !disableZones) {
      const zonesFromCity = zones.Data?.filter(
        (item) => item.ParentCode === model?.City?.Code,
      );
      setZones(zonesFromCity ?? []);
    }
  }, [zones, model?.City]);

  const handleStateChange = (currentState) => {
    if (!currentState) {
      setModel &&
        setModel({
          ...model,
          StateId: 0,
          State: null,
          CityId: 0,
          City: null,
        });
      return;
    }

    setModel &&
      setModel({
        ...model,
        StateId: currentState.Id,
        State: {
          ...currentState,
        },
        CityId: 0,
        City: null,
      });

    setCity(currentState.Code);
  };

  const handleCityChange = (currentCity) => {
    if (!currentCity) {
      setModel &&
        setModel({
          ...model,
          CityId: 0,
          City: null,
          ZoneId: 0,
          Zone: null,
        });
      return;
    }

    setModel &&
      setModel({
        ...model,
        CityId: currentCity.Id,
        City: {
          ...currentCity,
        },
        ZoneId:
          model?.Zone?.ParentCode === currentCity.Code ? model.Zone.Id : 0,
        Zone: model?.Zone?.ParentCode === currentCity.Code ? model.Zone : null,
      });

    setCityFilterCode(currentCity.Code);
  };

  const handleZoneChange = (currentZone) => {
    if (!currentZone) {
      setModel({
        ...model,
        ZoneId: 0,
        Zone: null,
      });
      return;
    }

    setModel({
      ...model,
      ZoneId: currentZone.Id,
      Zone: {
        ...currentZone,
      },
    });
  };

  const handleChange = (e) => {
    setModel && setModel({ ...model, [e.target.name]: e.target.value });
  };

  return (
    <Box className="w-full flex flex-col gap-3 mt-3">
      <Box className={getBoxStyle()}>
        <Combobox
          dontUseFullWidth
          isRequired
          id="State"
          fieldLabel={localize.department}
          fieldOptions={states ?? []}
          fieldValue={model?.State}
          handleValueChange={handleStateChange}
          popperFullWidth={PopperFullWidth}
        />

        <Combobox
          dontUseFullWidth
          isRequired
          id="CityId"
          fieldLabel={localize.city}
          fieldOptions={model?.State ? citiesData ?? [] : []}
          fieldValue={model?.City}
          handleValueChange={handleCityChange}
          popperFullWidth={PopperFullWidth}
        />
      </Box>

      {!disableZones && model?.City && zonesData?.length > 0 && (
        <Combobox
          id="ZoneId"
          fieldLabel={localize.zone}
          fieldOptions={model?.City ? zonesData ?? [] : []}
          fieldValue={model?.Zone}
          handleValueChange={handleZoneChange}
          popperFullWidth={PopperFullWidth}
        />
      )}

      {!disableAddress && (
        <TextField
          required
          InputLabelProps={getInputLabelProps()}
          inputProps={getInputProps()}
          size="small"
          value={model.Address}
          onChange={handleChange}
          id="Address"
          label={localize.address}
          name="Address"
          variant="outlined"
          fullWidth
          autoComplete="off"
        />
      )}

      {!disableAddressComplement && (
        <TextField
          InputLabelProps={getInputLabelProps()}
          inputProps={getInputProps()}
          size="small"
          id="AddressComplement"
          name="AddressComplement"
          value={model.AddressComplement}
          onChange={handleChange}
          label={localize.address_complement}
          variant="outlined"
          fullWidth
          autoComplete="off"
        />
      )}
    </Box>
  );
}
